import React from 'react';
import { useSelector } from 'react-redux';

const BtnRegulations = ({ text, icon, className, ...props }) => {

  const { activeContests, currentContestId } = useSelector((state) => state.contest);
  const currentContest = activeContests?.find((c) => String(c.id) === String(currentContestId));
  
  if(!currentContest?.regulationUrl)
    return null;
  

  return (
    <a href={currentContest?.regulationUrl} target="_blank" rel="noopener noreferrer" className={className}                >
      {text}
    </a>
  );
};

export default BtnRegulations;
